//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

export enum FilterMatchState {
  All = 'All',
  Any = 'Any',
}
